import React from 'react';

import { ClientRender } from '@change-corgi/core/react/ssr/render';

import { SupporterVoicesComments } from './components/SupporterVoicesComments';
import { SupporterVoicesVideos } from './components/SupporterVoicesVideos';
import { useSupporterVoicesSection } from './hooks/useSupporterVoicesSection';

export const SupporterVoices: React.FC = () => {
	const {
		data: { showSupporterVoicesSection },
	} = useSupporterVoicesSection();

	if (!showSupporterVoicesSection) {
		return <div className="hidden" data-testid="petition-page-supporters-voices-hidden" />;
	}

	return (
		<div data-testid="petition-page-supporters-voices">
			<ClientRender>
				<SupporterVoicesComments />
				<SupporterVoicesVideos />
			</ClientRender>
		</div>
	);
};
